
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetorajsthancab() {



    const cardData =
    {
        keyword: 'Pune to Rajasthan Cab ',
        heading: 'Platinum24 Cabs: Pune to Rajasthan Cab',
        headingDescription: ' Platinum24 Cabs offers trusted Pune to Rajasthan cab services, catering to pilgrims, tourists, and corporate travelers seeking a comfortable long-distance journey. Whether you’re planning to explore Jaipur’s forts, Udaipur’s lakes, Jodhpur’s palaces, or Jaisalmer’s desert dunes, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth and enjoyable ride. With experienced chauffeurs, timely pickups, and transparent pricing, we make intercity travel safe and stress-free. From one-way rides to tailor-made return trips across Rajasthan, Platinum24 Cabs guarantees dependable service and a memorable travel experience for every passenger.',

        top: 'Top Places to Visit in Rajasthan with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Jaipur – The Pink City",
    "description": "Jaipur, Rajasthan’s capital, is renowned for its forts, palaces, and vibrant markets. Amber Fort, Hawa Mahal, and City Palace showcase Rajput grandeur. Jantar Mantar, a UNESCO site, highlights scientific excellence. Shoppers flock to Johari Bazaar for gems and textiles. The city glows in pink hues, giving it a unique identity. Jaipur is Rajasthan’s royal cultural gateway."
  },
  {
    "title": "Udaipur – The City of Lakes",
    "description": "Udaipur is celebrated for its lakes, palaces, and romance. The Lake Palace and City Palace overlooking Lake Pichola are breathtaking. Jag Mandir and Sajjangarh Palace add to its charm. Sunset boat rides on Lake Pichola are unforgettable. The Aravalli Hills enhance its scenic beauty. Udaipur is Rajasthan’s romantic royal retreat."
  },
  {
    "title": "Jodhpur – The Blue City",
    "description": "Jodhpur is famous for Mehrangarh Fort, one of India’s largest forts towering above blue-painted houses. Jaswant Thada and Umaid Bhawan Palace add royal elegance. The bustling Sardar Market and Clock Tower area reflect local culture. Desert safaris in nearby Osian offer adventure. The city’s blue hue creates a magical skyline. Jodhpur is Rajasthan’s regal desert gem."
  },
  {
    "title": "Jaisalmer – The Golden City",
    "description": "Jaisalmer, located in the Thar Desert, glows with golden sandstone architecture. The Jaisalmer Fort is a living fort with shops, hotels, and homes. Patwon Ki Haveli and Nathmal Ki Haveli showcase intricate carvings. Desert safaris in Sam Sand Dunes include camel rides and cultural nights. Sunset over the desert is unforgettable. Jaisalmer is Rajasthan’s golden desert wonder."
  },
  {
    "title": "Mount Abu",
    "description": "Mount Abu, Rajasthan’s only hill station, offers a cool retreat from the desert heat. The Dilwara Temples, with exquisite marble carvings, are world-famous. Nakki Lake, Sunset Point, and Guru Shikhar are scenic attractions. The town’s greenery contrasts the arid surroundings. Adventure seekers enjoy trekking trails in the Aravallis. Mount Abu is Rajasthan’s serene mountain getaway."
  },
  {
    "title": "Pushkar",
    "description": "Pushkar is a sacred town known for the Brahma Temple, the only major temple of Lord Brahma in the world. The Pushkar Lake, with 52 ghats, is considered holy for rituals. The annual Pushkar Camel Fair is a global attraction, showcasing culture and trade. Colorful markets add vibrancy. Pilgrims and tourists alike love its spiritual aura. Pushkar is Rajasthan’s divine cultural hub."
  },
  {
    "title": "Ranthambore National Park",
    "description": "Ranthambore is one of India’s top tiger reserves, attracting wildlife enthusiasts from across the globe. Jeep safaris allow sightings of tigers, leopards, deer, and exotic birds. The park also houses Ranthambore Fort, a UNESCO heritage site. Lakes and ruins inside add historic charm. Photographers love its raw wilderness. Ranthambore is Rajasthan’s ultimate wildlife adventure."
  },
  {
    "title": "Chittorgarh Fort",
    "description": "Chittorgarh Fort, the largest fort in India, is a UNESCO World Heritage Site. It symbolizes Rajput valor and sacrifice, with stories of Rani Padmini and Rani Karnavati. The Vijay Stambh and Kirti Stambh are architectural marvels. Temples, palaces, and reservoirs enrich its grandeur. The fort sprawls across 700 acres of history. Chittorgarh is Rajasthan’s symbol of courage."
  },
  {
    "title": "Bikaner",
    "description": "Bikaner is known for Junagarh Fort, camel safaris, and Karni Mata Temple (Rat Temple). The fort houses ornate palaces and museums. The Camel Research Farm attracts tourists with unique camel rides. Bikaneri bhujia and sweets make it a foodie’s delight. The city’s desert culture is vibrant and colorful. Bikaner is Rajasthan’s cultural desert gem."
  },
  {
    "title": "Ajmer",
    "description": "Ajmer is a sacred city known for the Ajmer Sharif Dargah of Khwaja Moinuddin Chishti. Pilgrims of all faiths visit to seek blessings. Ana Sagar Lake and Akbari Fort add historic charm. The city is also a gateway to Pushkar. Festivals and qawwalis create a soulful vibe. Ajmer is Rajasthan’s spiritual and cultural center."
  }
],


        "services": [
    {
      "name": "Pune to Rajasthan Cab",
      "description": "Embark on a comfortable interstate journey with our Pune to Rajasthan Cab service. Designed for long-distance travelers, our service includes well-maintained vehicles, skilled drivers, and timely pickups to ensure a smooth and relaxing travel experience."
    },
    {
      "name": "Book Pune to Rajasthan Taxi",
      "description": "Easily Book Pune to Rajasthan Taxi online with our quick and secure platform. Choose your preferred car type, view transparent pricing, and receive instant booking confirmation. Ideal for families, solo travelers, and business professionals."
    },
    {
      "name": "Pune to Rajasthan Cab Booking",
      "description": "Our Pune to Rajasthan Cab Booking service ensures a hassle-free reservation process. Whether it’s a planned vacation or an urgent trip, our intuitive booking system, 24/7 support, and multiple payment options make it simple and stress-free."
    },
    {
      "name": "Pune to Rajasthan Car Rental",
      "description": "Explore flexible travel with our Pune to Rajasthan Car Rental options. Choose from self-drive or chauffeur-driven rentals, including sedans, SUVs, and luxury vehicles — perfect for family trips, road tours, or business travel."
    },
    {
      "name": "Affordable Pune to Rajasthan Cabs",
      "description": "Save on travel expenses with our Affordable Pune to Rajasthan Cabs. Ideal for cost-conscious travelers, this service offers budget-friendly fares, clean vehicles, and reliable service without compromising on comfort or safety."
    },
    {
      "name": "Pune to Rajasthan One Way Cab",
      "description": "Enjoy value and convenience with our Pune to Rajasthan One Way Cab service. Perfect for single-direction travel, you only pay for the journey you take. Ideal for business travelers, students, or relocations."
    },
    {
      "name": "Pune to Rajasthan Taxi Service",
      "description": "Experience dependable intercity travel with our Pune to Rajasthan Taxi Service. With courteous drivers, sanitized vehicles, and GPS navigation, we make your long journey safe, smooth, and timely."
    },
    {
      "name": "Cab from Pune to Rajasthan",
      "description": "Looking for a Cab from Pune to Rajasthan? Our service offers multiple vehicle choices, flexible departure times, and professional drivers to make your journey relaxed and enjoyable, whether it's for tourism or work."
    },
    {
      "name": "Rajasthan to Pune Taxi",
      "description": "Returning from Rajasthan? Our Rajasthan to Pune Taxi service ensures a comfortable ride back with on-time pickups, experienced drivers, and flexible booking options, maintaining high standards of safety and convenience."
    },
    {
      "name": "Pune to Rajasthan Outstation Cab",
      "description": "Our Pune to Rajasthan Outstation Cab service is ideal for extended travel across state lines. We offer roomy, well-equipped vehicles and experienced drivers, ensuring comfort, punctuality, and reliability for long-distance trips."
    },
    {
      "name": "Pune to Rajasthan Tour Taxi",
      "description": "Planning a tour? Choose our Pune to Rajasthan Tour Taxi for sightseeing, heritage trips, or vacations. We offer customized travel plans, professional drivers, and vehicles equipped for long journeys and multiple stops."
    },
    {
      "name": "Pune to Rajasthan Travel by Car",
      "description": "Enjoy scenic and flexible Pune to Rajasthan Travel by Car. Perfect for those who prefer personalized schedules, this service allows comfortable stopovers and relaxed travel at your pace, with trained drivers and clean vehicles."
    },
    {
      "name": "Taxi from Pune to Rajasthan",
      "description": "Hire a Taxi from Pune to Rajasthan for safe and efficient interstate travel. With options ranging from economy to premium cars, we cater to every travel need — whether business, personal, or leisure."
    }
  ],
  "tableData": [
    ["Pune to Rajasthan Cab", "Book Pune to Rajasthan Taxi"],
    ["Pune to Rajasthan Cab Booking", "Pune to Rajasthan Car Rental"],
    ["Affordable Pune to Rajasthan Cabs", "Pune to Rajasthan One Way Cab"],
    ["Pune to Rajasthan Taxi Service", "Cab from Pune to Rajasthan"],
    ["Rajasthan to Pune Taxi", "Pune to Rajasthan Outstation Cab"],
    ["Pune to Rajasthan Tour Taxi", "Pune to Rajasthan Travel by Car"],
    ["Taxi from Pune to Rajasthan", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Rajasthan Cab Service",
    "WhyChoosedescription": "Platinum24 Cabs provides reliable and comfortable cab services from Pune to various cities in Rajasthan for a hassle-free journey."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles for Every Travel Need",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers to match your group size and comfort for the long Pune to Rajasthan trip."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Cabs",
    "WhyChoosedescription": "All vehicles are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience on long routes like Pune to Rajasthan."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Inter-State Routes",
    "WhyChoosedescription": "Our professional drivers have extensive experience with Pune to Rajasthan routes, ensuring smooth and timely travel."
  },
  {
    "WhyChooseheading": "Affordable Rates with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent pricing with all costs like tolls, fuel, and driver allowances included in your Pune to Rajasthan cab fare."
  },
  {
    "WhyChooseheading": "24/7 Support for Seamless Booking",
    "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist with your Pune to Rajasthan cab booking and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages to Suit Your Itinerary",
    "WhyChoosedescription": "Whether it’s a one-way trip, round trip, or multi-day tour, we offer customizable packages for your Rajasthan travel."
  },
  {
    "WhyChooseheading": "Quick Online Booking and Instant Confirmation",
    "WhyChoosedescription": "Book your cab from Pune to Rajasthan easily through our website or app, and receive instant booking confirmation."
  }
]

















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Rajasthan cab service?',
        answer: 'Yes, Platinum24 Cabs offers reliable intercity cab services from Pune to various destinations across Rajasthan.',
    },
    {
        question: 'How do I book a cab from Pune to Rajasthan with Platinum24 Cabs?',
        answer: 'You can book easily through our website, mobile app, or by contacting our 24x7 customer care team.',
    },
    {
        question: 'What vehicle options are available for Pune to Rajasthan travel?',
        answer: 'We provide a range of vehicles including hatchbacks, sedans, SUVs, and luxury cars for your Pune to Rajasthan journey.',
    },
    {
        question: 'Is one-way cab booking available from Pune to Rajasthan?',
        answer: 'Yes, we offer both one-way and round-trip cab services from Pune to Rajasthan.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Rajasthan?',
        answer: 'Yes, our drivers are experienced, licensed, and familiar with the routes between Pune and cities in Rajasthan.',
    },
    {
        question: 'Can I select my own pickup and drop-off locations in Pune and Rajasthan?',
        answer: 'Absolutely, you can customize your pickup and drop-off points as per your travel convenience.',
    },
    {
        question: 'What safety measures are taken for Pune to Rajasthan cab services?',
        answer: 'All cabs are sanitized regularly, and drivers follow strict hygiene and safety protocols throughout the trip.',
    },
    {
        question: 'Is the Pune to Rajasthan cab service available 24x7?',
        answer: 'Yes, we offer round-the-clock cab services from Pune to Rajasthan to match your travel schedule.',
    },
    {
        question: 'Which payment options are accepted for Pune to Rajasthan bookings?',
        answer: 'We accept UPI, digital wallets, credit/debit cards, and cash for your convenience.',
    },
    {
        question: 'Do you offer customizable packages for Pune to Rajasthan cab service?',
        answer: 'Yes, our cab packages are flexible and can be tailored to your travel needs and itinerary.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vijay Singh',
        feedback: 'Took a cab from Pune to Udaipur with Platinum24 Cabs — smooth ride, courteous driver, and no delays.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Aarti Desai',
        feedback: 'Our family trip from Pune to Rajasthan was made extra special by the great service of Platinum24 Cabs.',
        rating: 5,
    },
];







































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const puneToRajasthanCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Rajasthan Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-rajasthan-cab.jpg",
  "description": "Book Pune to Rajasthan cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6499",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-rajasthan-cab-service"
  }
};








    return (
        <div>


<Helmet>
  <title>Pune to Rajasthan Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Rajasthan cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Rajasthan Cab, Book Pune to Rajasthan Taxi, Pune to Rajasthan Cab Booking, Pune to Rajasthan Car Rental, Affordable Pune to Rajasthan Cabs, Pune to Rajasthan One Way Cab, Pune to Rajasthan Taxi Service, Cab from Pune to Rajasthan, Rajasthan to Pune Taxi, Pune to Rajasthan Outstation Cab, Pune to Rajasthan Tour Taxi, Pune to Rajasthan Travel by Car, Taxi from Pune to Rajasthan"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToRajasthanCabSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/100.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetorajsthancab;